export default {
  id: null,
  regulationAutoID: null,
  budgetedLabor: null,
  approvedLabor: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/typing/modal/modalsinistertyping-model.js